import floor from "planets/racion/racion-checkpoint.svg"
import stone from "planets/racion/racion-stone-3.svg"

export default {
  mainColor: "#c9fff5",
  secondaryColor: "#ffffff",
  floor: {
    image: floor,
    height: 152
  },
  stone: {
    image: stone,
    width: 72,
    height: 99,
    left: 40
  }
}
